function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/* eslint-disable object-curly-newline */
/* eslint-disable no-undef */
import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { DeleteAd, AdDeleted, Survey, Bump, SurveySent, DeleteError } from '../components';
import { CustomStyles, Step } from '../constants';
import { sendEvent } from '../util/tracking';
import Config from '../config';

// Modal.setAppElement('#root')

var DeleteAdContainer = function (_Component) {
  _inherits(DeleteAdContainer, _Component);
  function DeleteAdContainer(props) {
    _classCallCheck(this, DeleteAdContainer);
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
    _this.nextStep = function (step) {
      _this.setState({
        step: step
      });
    };
    _this.closeModal = function (name) {
      if (name) {
        sendEvent({
          event_type: 'click',
          object_detail: 'modal_dismiss',
          object_name: name
        });
      }
      if (_this.state.step === Step.AD_DELETED) {
        _this.state.onAdDeletedSuccess(_this.state.reason);
      }
      _this.setState({
        isModalOpen: false
      });
      _this.state.onClose();
    };
    _this.handleChange = function (event) {
      var _this$setState;
      var _event$target = event.target,
        name = _event$target.name,
        value = _event$target.value;
      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
    };
    _this.customStyle = function () {
      if (window.innerWidth < Config.MOBILE_MAX_WIDTH) {
        CustomStyles.content.display = 'flex';
        CustomStyles.content.width = '95%';
      }
      return CustomStyles;
    };
    _this.renderSteps = function (values) {
      var noSurvey = _this.state.noSurvey;
      switch (_this.state.step) {
        case Step.AD_DELETED:
          return React.createElement(AdDeleted, {
            closeModal: _this.closeModal,
            nextStep: _this.nextStep
          });
        case Step.SURVEY_SENT:
          return React.createElement(SurveySent, {
            closeModal: _this.closeModal
          });
        case Step.SURVEY:
          return React.createElement(Survey, {
            nextStep: _this.nextStep,
            closeModal: _this.closeModal,
            handleChange: _this.handleChange,
            values: values
          });
        case Step.BUMP:
          return React.createElement(Bump, {
            nextStep: _this.nextStep,
            closeModal: _this.closeModal,
            handleChange: _this.handleChange,
            values: values
          });
        case Step.DELETE_ERROR:
          return React.createElement(DeleteError, {
            closeModal: _this.closeModal,
            nextStep: _this.nextStep
          });
        default:
          return React.createElement(DeleteAd, {
            nextStep: _this.nextStep,
            closeModal: _this.closeModal,
            handleChange: _this.handleChange,
            values: values,
            noSurvey: noSurvey
          });
      }
    };
    _this.state = {
      step: Step.DELETE_AD,
      isModalOpen: props.isOpen,
      reason: '',
      rating: '',
      message: '',
      packageType: '',
      title: props.title,
      adId: props.adId,
      listId: props.listId,
      style: _this.customStyle(),
      onClose: props.onClose,
      onAdDeletedSuccess: props.onAdDeletedSuccess,
      noSurvey: props.noSurvey
    };
    return _this;
  }
  DeleteAdContainer.prototype.render = function render() {
    var _this2 = this;
    var _state = this.state,
      reason = _state.reason,
      rating = _state.rating,
      message = _state.message,
      packageType = _state.packageType,
      listId = _state.listId,
      title = _state.title,
      adId = _state.adId;
    var values = {
      reason: reason,
      rating: rating,
      message: message,
      packageType: packageType,
      adId: adId,
      listId: listId,
      title: title
    };
    return React.createElement(Modal, {
      ariaHideApp: false,
      isOpen: this.state.isModalOpen,
      onRequestClose: function onRequestClose() {
        return _this2.closeModal(_this2.state.step);
      },
      style: this.state.style,
      contentLabel: 'Exclus\xE3o de an\xFAncio'
    }, this.renderSteps(values));
  };
  return DeleteAdContainer;
}(Component);
DeleteAdContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  title: PropTypes.string,
  adId: PropTypes.string,
  listId: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onAdDeletedSuccess: PropTypes.func,
  noSurvey: PropTypes.bool
} : {};
export default DeleteAdContainer;